import React from 'react';
import { DigitMapping, PriceCodeDisplayProps } from '../../types';


const PriceCodeDisplay: React.FC<PriceCodeDisplayProps> = ({ number, className }) => {
  const encodeNumber = (num: number | string): string => {
    try {
      // Get mappings from localStorage
      const stored = localStorage.getItem('priceCode_mappings');
      if (!stored) {
        return 'No mappings';
      }

      const mappings: DigitMapping[] = JSON.parse(stored);
      
      // Create lookup object
      const mappingLookup: { [key: number]: string } = {};
      mappings.forEach(mapping => {
        mappingLookup[mapping.digit] = mapping.character;
      });

      // Encode the number
      return num.toString()
        .split('')
        .map(digitChar => {
          const digit = parseInt(digitChar, 10);
          return mappingLookup[digit] || '.';
        })
        .join('');

    } catch (error) {
      return 'Error';
    }
  };

  return (
    <span className={className} style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
      {encodeNumber(number)}
    </span>
  );
};

export default PriceCodeDisplay;